import { createFileRoute } from '@tanstack/react-router'
import { AdminAuthGate } from '../components/auth/admin-auth-gate'
import { AdminBookings } from '../components/pages/AdminBookings'

export const Route = createFileRoute('/admin_/bookings')({
  validateSearch: (search: Record<string, unknown>) => ({
    booking: typeof search.booking === 'string' ? search.booking : undefined,
    action: search.action === 'edit' || search.action === 'cancel' || search.action === 'delete'
      ? search.action
      : undefined,
  }),
  component: AdminBookingsComponent,
  head: () => ({
    title: 'Bookings | AUTOGLOW Detailing Admin',
    meta: [
      { title: 'Bookings | AUTOGLOW Detailing Admin' },
      { name: 'robots', content: 'noindex,nofollow' },
    ],
  }),
})

function AdminBookingsComponent() {
  const search = Route.useSearch()
  const action = search.action === 'edit' || search.action === 'cancel' || search.action === 'delete'
    ? search.action
    : undefined
  return (
    <AdminAuthGate>
      <AdminBookings action={action} bookingReference={search.booking} />
    </AdminAuthGate>
  )
}
